import React from 'react'

export const SocialMediaIcon = ({props}) => {
    return (
        <a 
            href={props.link} 
            target="_blank" 
            rel='noreferrer'
        >
            <div className="bg-icon">
                {props.icon}
            </div>
        </a>
    )
}

